const apiUrl = process.env.REACT_APP_API_URL;

export const PutJutgeCazaTest = async (id: string, test: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${id}/test`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(test)
            });
        return response.ok;
    } catch (error) {
        console.log('Error al guardar el test de caza:', error);
        return false;
    }
};
